import { Building2, LifeBuoy } from "lucide-react";
import Link from "next/link";

export default function CustomLink({ locale }: { locale: string }) {
  const LINKS = [
    {
      href: `/${locale}/explore`,
      label: locale === "ar" ? "استكشف" : "Explore",
      Icon: Building2,
    },
    {
      href: `/${locale}/help`,
      label: locale === "ar" ? "المساعدة" : "Help",
      Icon: LifeBuoy,
    },
  ];

  return (
    <div className="hidden md:flex items-center gap-6">
      {LINKS.map(({ href, label, Icon }) => (
        <Link
          key={href}
          href={href}
          className="flex items-center gap-2 text-sm font-medium text-neutral-700 dark:text-neutral-300 hover:text-[var(--brand)] dark:hover:text-white transition-colors group"
        >
          <Icon
            size={24}
            className="text-neutral-400 group-hover:text-[var(--brand)] transition-colors"
          />
          <span>{label}</span>
        </Link>
      ))}
    </div>
  );
}
